import _extends from "@babel/runtime/helpers/esm/extends";
var _IconClose;
import { Box, Modal } from '@mui/material';
import React, { useEffect, useRef, createElement as _createElement } from 'react';
import Button from "../../atoms/Button";
import { IconClose } from "../../atoms/Icon";
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import { disableScrollBody } from "../../utils/disableScrollBody";
import ItemProduct from "./ItemProduct";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ModalCartSoldOut = props => {
  const {
    open,
    onClose,
    listItems = [],
    buttonProps,
    locale,
    title,
    currencySymbol
  } = props;
  const refContent = useRef();

  // useEffect(() => {
  //     setTimeout(() => {
  //         if (typeof window !== "undefined") {
  //             const wrapper = refContent.current;
  //             if (wrapper) {
  //                 const width = wrapper.clientWidth;
  //                 if (wrapper?.style) {
  //                     wrapper.style.height = `${width}px`;
  //                 }
  //             }

  //             window.addEventListener("resize", () => {
  //                 const wrapperItem = refContent.current;
  //                 if (wrapperItem) {
  //                     const width = wrapperItem.clientWidth;
  //                     if (wrapperItem?.style) {
  //                         wrapperItem.style.height = `${width}px`;
  //                     }
  //                 }
  //             })
  //         }
  //         return () => {
  //             window.removeEventListener("resize", () => { })
  //         }
  //     }, 1000);
  // }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      disableScrollBody(open);
    }
  }, [open]);
  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "auto"
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      },
      onClick: () => onClose?.(),
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: {
            xs: "90%",
            md: "60%",
            xl: "49%"
          },
          padding: "32px 27.5px 60px 27.5px",
          maxWidth: "547px",
          // maxHeight: "547px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative"
          // "& img": {
          //     width: "100%",
          //     height: "calc(100% - 32px)",
          //     objectFit: "cover"
          // }
        },
        ref: refContent,
        onClick: e => {
          e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            position: "absolute",
            top: "16px",
            right: "16px",
            cursor: "pointer"
          },
          onClick: () => onClose?.(),
          children: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {}))
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            marginTop: '20px'
          },
          children: title
        }), !!listItems.length && listItems.map((item, idx) => /*#__PURE__*/_createElement(ItemProduct, _extends({}, item, {
          key: idx,
          currencySymbol: currencySymbol,
          locale: locale
        }))), buttonProps?.label && /*#__PURE__*/_jsx(Box, {
          sx: {
            marginTop: '40px',
            width: '100%',
            '& a': {
              width: '100%',
              marginBottom: '0px'
            }
          },
          children: /*#__PURE__*/_jsx(Button, {
            externalLink: `/${locale}/${buttonProps?.href}`,
            variant: buttonProps?.variant,
            label: buttonProps?.label,
            sx: {
              maxWidth: '100%',
              with: '100%',
              height: "46px !important",
              marginBottom: {
                xs: "16px",
                md: "0px"
              }
            }
          })
        })]
      })
    })
  });
};
export default ModalCartSoldOut;